<main class="main-container" [class.open-hamburger-menu]="navOpen()">
  <header class="header header-6" [ngClass]="'env-' + stage">
    <!-- Clarity's built-in off-canvas nav (active <=992px). The trigger must
         precede .branding: the sibling rules in clr-ui handle mobile branding
         compaction. Hidden >=993px by Clarity's base CSS. -->
    <button
      type="button"
      class="header-hamburger-trigger"
      [class.active]="navOpen()"
      aria-label="Navigation umschalten"
      [attr.aria-expanded]="navOpen()"
      (click)="toggleNav()"
    >
      <span></span>
    </button>
    <div class="branding">
      <a routerLink="/" class="nav-link">
        <img src="assets/orf-brick.svg" alt="ORF Logo" />
        <span class="title">{{ title }}</span>
      </a>
    </div>
    <div class="header-nav clr-nav-level-1">
      @if (navOpen()) {
        <button type="button" class="clr-nav-close" aria-label="Navigation schließen" (click)="closeNav()">
          <span></span>
        </button>
      }
      <a class="nav-link" routerLink="/dashboard" (click)="closeNav()" *hasPermission="'view-dashboard'">
        <span class="nav-text">Dashboard</span>
      </a>
      <a class="nav-link" routerLink="/programplan" (click)="closeNav()" *hasPermission="'view-programplan'">
        <span class="nav-text">Programmplan</span>
      </a>
      <a class="nav-link" routerLink="/archive" (click)="closeNav()" *hasPermission="'view-archive'">
        <span class="nav-text">Archiv</span>
      </a>
      <a class="nav-link" routerLink="/statistics" (click)="closeNav()" *hasPermission="'view-statistics'">
        <span class="nav-text">Statistiken</span>
      </a>
    </div>
    @if (navOpen()) {
      <div class="header-backdrop" (click)="closeNav()"></div>
    }
    <div class="header-actions">
      <span class="env-badge" [ngClass]="'env-' + stage">{{ stage | uppercase }}</span>

      @if(!authService.isLoggedIn()) {
        <div class="nav-link" (click)="login()">
          <cds-icon shape="user"></cds-icon>
        </div>
      }

      @if(authService.isLoggedIn()) {
        <div class="nav-link user-info-wrapper">
          <div class="user-details">
            <div class="user-name">
              <cds-icon shape="user"></cds-icon> {{ authService.userName() }}
            </div>
            <div class="user-groups" [title]="(authService.groups())?.join(', ')">
              ({{ (authService.groups())?.join(', ') }})
            </div>
          </div>
          <div class="logout-btn" (click)="logout()" title="Logout">
            <cds-icon shape="logout"></cds-icon>
          </div>
        </div>
      }

    </div>
  </header>
  <div class="content-container">
    <div class="content-area">
      <router-outlet />
    </div>
  </div>

</main>
